<template>
    <div @mousedown="emitClicked">
        <button id="session-warning-button"
                data-toggle="modal"
                data-target="#session-warning"
                class="d-none"
        > WARNING</button>

        <button id="session-expired-button"
                data-toggle="modal"
                data-target="#session-expired"
                class="d-none"
        > EXPIRED</button>

        <navbar></navbar>
        <router-view id="routes"></router-view>

        <div id="session-warning" class="modal fade" tabindex="-1" role="dialog" aria-labelledby="session-warning-title" aria-hidden="true" data-backdrop="static" data-keyboard="false">
            <div class="modal-dialog modal-dialog-centered" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="session-warning-title">EXPIRING SESSION</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close" id="session-warning-close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <p>You session will expire in {{ idleLimit - idleTIme }}.</p>
                    </div>
                    <div class="modal-footer text-center">
                        <button type="button" class="btn btn-secondary" @click="logout">Logout</button>
                        <button type="button" class="btn btn-primary" @click="refreshSession" data-dismiss="modal">Stay Connected</button>
                    </div>
                </div>
            </div>
        </div>

        <div id="session-expired" class="modal fade" tabindex="-1" role="dialog" aria-labelledby="session-expired-title" aria-hidden="true" data-backdrop="static" data-keyboard="false">
            <div class="modal-dialog modal-dialog-centered" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="session-expired">SESSION EXPIRED</h5>
                    </div>
                    <div class="modal-body">
                        <p>Please sign in to renew your session or click exit.</p>
                    </div>
                    <div class="modal-footer text-center">
                        <button type="button" class="btn btn-secondary" @click="homePage">EXIT</button>
                        <button type="button" class="btn btn-primary" @click="logout" data-dismiss="modal">LOGIN</button>
                    </div>
                </div>
            </div>
        </div>



    </div>
</template>

<script>

    import Navbar from "../components/layouts/Navbar";
    import { IDLE_LIMIT, HOME_PAGE, IDLE_WARNING } from "@/services/ServerConstant";
    import { mapActions } from 'vuex';
    import { EventBus } from "@/main";

    export default {
        name: "Base",

        data() {
            return {
                idleTIme: 0,
                idleLimit: IDLE_LIMIT,
                expired: false,
                interval: null
            }
        },

        components: {
            Navbar //, Principal, Manning
        },

        methods: {
            ...mapActions([
                'clearStorage',
            ]),

            emitClicked(source) {
                EventBus.$emit('clicked', source);
            },

            logout() {
                this.$router.push({ name: 'Login'});
            },

            refreshSession() {
                localStorage.setItem('idleSeconds', 0);
            },

            homePage() {
                clearInterval(this.interval);
                window.location.href = HOME_PAGE;
            }

        },

        created() {
            let idleWarning = this.idleLimit - IDLE_WARNING;

            localStorage.setItem('idleSeconds', 0);
            this.interval = setInterval(() => {
                if(!this.expired) {
                    let idleSeconds = parseInt(localStorage.getItem('idleSeconds'));
                    if(idleSeconds === idleWarning) {
                        document.getElementById('session-warning-button').click();
                    } else if(idleSeconds >= this.idleLimit) {
                        document.getElementById('session-warning-close').click();
                        document.getElementById('session-expired-button').click();
                        this.clearStorage();
                        this.expired = true;
                    }
                    this.idleTIme = idleSeconds + 1;
                    localStorage.setItem('idleSeconds', this.idleTIme);
                }
            }, 1000);

        },

    }

</script>

<style scoped>
    div #routes{
        overflow-x: hidden;
    }
</style>
